module.exports = __webpack_public_path__ + "img/logo.5d4532f1.svg";